import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES } from 'Services/analytics/analytics.const';
import type { GetSnowplowEventPayloadProps } from 'Services/analytics/analytics.types';

export type BaseMoveEventProps<CustomData extends UnknownShapeObject> = GetSnowplowEventPayloadProps<CustomData>;

export type MoveEventProps<CustomData extends UnknownShapeObject> = Omit<BaseMoveEventProps<CustomData>, 'category'>;

export function baseMoveEvent<CustomData extends UnknownShapeObject>({
	category,
	customData,
	name,
	schemaName,
	version,
}: BaseMoveEventProps<CustomData>): void {
	logAnalyticsEvent({
		eventPayload: getSnowplowEventPayload({
			category,
			customData,
			name,
			schemaName,
			version,
		}),
		provider: 'SNOWPLOW',
	});
}

export function motorwayMovePageEvents<CustomData extends UnknownShapeObject>(props: MoveEventProps<CustomData>): void {
	baseMoveEvent({
		category: ANALYTICS_CATEGORIES.MOTORWAY_MOVE_PAGE,
		...props,
	});
}
